import { useEffect } from "react";

export default function Refund() {
  useEffect(() => {
    document.title = "Refund Policy — Sutranode";
  }, []);

  return (
    <section className="section legal-section">
      <div className="container legal-container">
        <div className="s-eyebrow">Refunds</div>
        <h1 className="s-title">Refund Policy</h1>
        <p className="legal-updated">Last updated: 5 May 2026</p>
        <div className="legal-body" style={{ marginTop: 24 }}>
          <h2>1. Our approach</h2>
          <p>
            We work hard to be the right fit before any payment is made. The discovery call, written
            brief, and clear scope exist to make sure both sides know exactly what they're signing up
            for. That said, things can change — and here's how we handle it.
          </p>

          <h2>2. Before work begins</h2>
          <p>
            If you've paid a kickoff fee but no work has started yet, you can request a full refund
            within 5 days of payment. Once project work has begun, refunds are handled per the section
            below.
          </p>

          <h2>3. Mid-project</h2>
          <p>
            If you decide to end the engagement mid-project, we'll bill you for the work completed up
            to that point and refund any unused balance from milestones already paid. You receive
            clean handover of everything completed.
          </p>

          <h2>4. After delivery</h2>
          <p>
            Once a project is delivered and accepted, refunds are not available. We do offer a
            reasonable post-launch support window for fixes and adjustments — defined per project in
            the brief.
          </p>

          <h2>5. Retainers</h2>
          <p>
            Retainers can be cancelled with 30 days' notice. The current month is non-refundable as
            work is already underway, but no future months will be billed.
          </p>

          <h2>6. How to request a refund</h2>
          <p>
            Email <strong>hello@sutranode.in</strong> with your project details and reason for the
            request. We'll reply within 3 working days.
          </p>

          <h2>7. Disputes</h2>
          <p>
            If we can't reach a resolution directly, disputes will be handled per Indian law in the
            jurisdiction where Sutranode is registered.
          </p>
        </div>
      </div>
    </section>
  );
}
